var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#865df9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M769.628,600.111h0a8,8,0,0,0-8,8h0a8,8,0,0,0,8,8h0a8,8,0,0,0,8-8h0A8,8,0,0,0,769.628,600.111Zm-5.142,5.317,1.419-2.48a.567.567,0,0,1,.492-.285h6.6a.567.567,0,0,1,.486.285l1.422,2.483a1.393,1.393,0,0,1-1.125,1.97h-.115a1.463,1.463,0,0,1-1.245-.692.094.094,0,0,0-.163,0,1.463,1.463,0,0,1-2.48.015.095.095,0,0,0-.161,0,1.463,1.463,0,0,1-2.48-.016.1.1,0,0,0-.033-.033.1.1,0,0,0-.13.033,1.463,1.463,0,0,1-1.245.692,1.5,1.5,0,0,1-.158-.008A1.392,1.392,0,0,1,764.486,605.428Zm10.255,7.438h-9.955a.561.561,0,1,1,0-1.122h.647v-3.612l.057.007a5.045,5.045,0,0,1,3.767-.17v3.774h3.715v-3.726a2.345,2.345,0,0,0,.692.1,1.611,1.611,0,0,0,.18-.007,2.251,2.251,0,0,0,.254-.035v3.665h.647a.561.561,0,0,1,0,1.122Z",
    transform: "translate(-761.628 -600.111)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.99245a243db470d5fefc6bfbe79a4efb.svg";
export { ForwardRef as ReactComponent };